import translate from 'translate-js';

let localStorageCartonomyHashKey = `cartonomy_shopify_url_hash`;

export const utils = {
    $: null,
    localStorageCartonomyHashKey,
    isIOS: (/ios|iphone|android/gi).test(navigator.userAgent),
    isIOSMobile:  (/ios|iphone/gi).test(navigator.userAgent),
    bodyDOM: null,
    headDOM: null,
    cartonomyBaseUrl: '//apppartner1.cartonomy.com',
    cartonomyApiUrl: 'https://apipartner1.cartonomy.com/api/',
    retailerShop: '',
    hash: decodeURIComponent(window.location.hash) || window.localStorage.getItem(localStorageCartonomyHashKey) || '',
    cartonomyOpenIndicatorName: 'cartonomy-opened',
    addToGroupCartButtonId: 'AddToGroupCart',
    possibleProductVariantSelector: [],
    possibleProductQuantitySelector: [],
    ignoreTriggerCloseSelector: [],
    localStorageAddCartBtnTextKey: `cartonomy_group_shopping_button_text`,
    myGroupOrdertButtonText: `client.button.my_group_order`,
    addToCartButtonText: `client.button.add_to_new_order`,
    addToMyCartButtonText: `client.button.add_to_my_cart`,
    addToMyGroupButtonText: `client.button.add_to_my_group`,
    customCartnameValue: 'client.external.custom_cart_name',
    externalStoreWindowTitle: 'client.external.external_store_title',
    originalWidget: {
        width: null,
        height: null
    },
    customAvatarText: '',
    moneyFormat: '',
    isInvitingMode() {
        return this.hash.toLowerCase().indexOf('invite/') > -1;
    },

    isOauthCallbackMode() {
        return this.hash.toLowerCase().indexOf('auth_token') > -1;
    },

    isShowedCartonomyOnPages() {
        //Apply for Shopify
        return window.location.href.indexOf('/collections/') > -1 || window.location.href.indexOf('/products/') > -1;
    },

    isAlwaysShowCartonomy() {
        return window.location.hash.indexOf('/invite/') > -1 || window.location.pathname === '/';
    },

    toPossessiveString(name) {
        return translate('client.possessive_name', {name: name});
    },
    compileMyCartButtonText(value, shouldTranslate = true){
        if(!value)
            return shouldTranslate ?  translate(this.addToMyCartButtonText) : this.addToMyCartButtonText;

        return shouldTranslate ? translate('client.button.add_to', {user: translate(value)}) : 'client.button.add_to';
    },
    findClosest(selector, fromChild){
        let parent = fromChild.parent();
        while(parent) {
            if (parent.is('body'))
                return null;

            if (parent.is(selector))
                return parent;

            parent = parent.parent();
        }

        return null;
    },

    checkIfIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf("Trident");
  
      return msie > 0;
    }
};



// WEBPACK FOOTER //
// ./src/utils/shopifyInjector/utils.js